<template>
  <div v-if="currentUser && currentUser.role_id === 5" class="specialists-page">
    <div class="page-header">
      <div>
        <h1>Specjaliści</h1>
        <p>Zarządzaj specjalistami przypisanymi do Twojej placówki.</p>
      </div>

      <RouterLink to="/firm-profile/specialists/add" class="header-link">
        <button class="btn-primary">Dodaj specjalistę</button>
      </RouterLink>
    </div>

    <section class="section-card filters-card">
      <label class="checkbox-row" for="showOnlyActive">
        <input
            type="checkbox"
            name="showOnlyActive"
            id="showOnlyActive"
            v-model="showOnlyActive"
            @change="getSpecialists()"
        >
        <span>Pokaż tylko specjalistów, którzy zaakceptowali zaproszenie.</span>
      </label>
    </section>

    <section class="section-card specialists-card">
      <div class="section-title">
        <h2>Lista specjalistów</h2>
        <span v-if="specialists" class="counter">{{ specialists.length }}</span>
      </div>

      <div v-if="specialists && specialists.length" class="specialists-grid">
        <article
            class="specialist-item"
            :class="{ 'specialist-item--active': spec.active }"
            v-for="spec in specialists"
            :key="spec.id"
        >
          <div class="status-badge" :class="{ 'status-badge--active': spec.active }">
            {{ spec.active ? 'Aktywny' : 'Oczekuje' }}
          </div>

          <img class="avatar" src="@/assets/photo-placeholder.png" alt="brak zdjęcia">

          <RouterLink class="specialist-name" :to="`/browse/user/${spec.business.id}`">
            {{ spec.business.firstname }} {{ spec.business.lastname }}
          </RouterLink>

          <p class="specialist-email" v-if="spec.business.email">
            {{ spec.business.email }}
          </p>

          <button class="btn-danger" @click="removeSpecialist(spec.business.id)">
            Usuń
          </button>
        </article>
      </div>

      <div v-else class="empty-state">
        <h3>Brak specjalistów</h3>
        <p>Nie masz jeszcze dodanych specjalistów lub lista jest pusta dla wybranych filtrów.</p>
        <RouterLink to="/firm-profile/specialists/add">
          <button class="btn-primary">Dodaj pierwszego specjalistę</button>
        </RouterLink>
      </div>
    </section>
  </div>

  <div v-else class="fallback">
    <h2>Błąd wczytywania. Spróbuj ponownie.</h2>
  </div>
</template>

<script>
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useMeta } from 'vue-meta';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'SpecialistsManagement',
  data() {
    return {
      showOnlyActive: false,
      specialists: null,
      allSpecialists: null
    };
  },
  setup() {
    useMeta({ title: 'specjaliści' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore()
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 5) {
      this.$router.push('/login');
    }

    this.getSpecialists();
  },
  methods: {
    getSpecialists() {
      if (this.allSpecialists) {
        this.specialists = this.showOnlyActive
            ? this.allSpecialists.filter(item => item.active)
            : this.allSpecialists;
        return;
      }

      axios.get(`/FirmBusinessList/${this.currentUser.id}`, authHeader()).then(res => {
        this.allSpecialists = res.data.items;
        this.specialists = this.showOnlyActive
            ? this.allSpecialists.filter(item => item.active)
            : this.allSpecialists;
      });
    },
    removeSpecialist(id) {
      axios.delete(`/FirmBusiness/${id}`, authHeader()).then(res => {
        if (res && String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie usunięto specjalistę');
          this.allSpecialists = null;
          this.getSpecialists();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.specialists-page {
  background: #ffffff;
  min-height: 100vh;
  padding: 24px 16px 32px;
  color: #1f2937;
}

.page-header {
  max-width: 1200px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 14px;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
}

.page-header p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.header-link {
  text-decoration: none;
}

.section-card {
  max-width: 1200px;
  margin: 0 auto 20px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 16px;
  box-sizing: border-box;
}

.filters-card {
  display: flex;
  align-items: center;
}

.checkbox-row {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #374151;
  font-size: 1.35rem;
  cursor: pointer;
}

.checkbox-row input {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #f97316;
}

.specialists-card {
  min-height: 240px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.section-title h2 {
  margin: 0;
  font-size: 2rem;
}

.counter {
  background: #fff7ed;
  color: #9a3412;
  border: 1px solid #fed7aa;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 1.25rem;
  font-weight: 700;
}

.specialists-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.specialist-item {
  position: relative;
  border: 1px solid #fed7aa;
  border-left: 4px solid #f97316;
  border-radius: 12px;
  padding: 18px 14px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.specialist-item--active {
  border-color: #bbf7d0;
  border-left-color: #16a34a;
}

.status-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #fff7ed;
  color: #9a3412;
  border: 1px solid #fed7aa;
  border-radius: 999px;
  padding: 3px 8px;
  font-size: 1.15rem;
  font-weight: 700;
}

.status-badge--active {
  background: #f0fdf4;
  color: #166534;
  border-color: #bbf7d0;
}

.avatar {
  width: 96px;
  height: 96px;
  margin-top: 12px;
  border-radius: 999px;
  object-fit: cover;
  border: 2px solid #e5e7eb;
}

.specialist-name {
  color: #1f2937;
  font-size: 1.55rem;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
}

.specialist-name:hover {
  color: #10b981;
}

.specialist-email {
  margin: 0;
  color: #6b7280;
  font-size: 1.25rem;
  text-align: center;
  word-break: break-word;
}

.empty-state {
  min-height: 180px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  background: #f9fafb;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
}

.empty-state h3 {
  margin: 0;
  font-size: 1.8rem;
}

.empty-state p {
  margin: 0 0 8px;
  max-width: 480px;
  color: #6b7280;
  font-size: 1.35rem;
  line-height: 1.5;
}

.empty-state a {
  text-decoration: none;
}

.btn-primary,
.btn-danger {
  border-radius: 8px;
  font-size: 1.35rem;
  cursor: pointer;
}

.btn-primary {
  background: #f97316;
  color: #ffffff;
  border: none;
  padding: 10px 14px;
  font-weight: 600;
}

.btn-primary:hover {
  background: #ea6c0a;
}

.btn-danger {
  width: 100%;
  margin-top: 8px;
  background: #dc3545;
  color: #ffffff;
  border: none;
  padding: 10px 14px;
}

.btn-danger:hover {
  background: #b91c1c;
}

.fallback {
  padding: 24px;
  text-align: center;
}

@media (max-width: 480px) {
  .specialists-page {
    padding: 16px 12px 24px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .header-link,
  .btn-primary {
    width: 100%;
  }

  .btn-primary {
    text-align: center;
  }

  .specialists-grid {
    grid-template-columns: 1fr;
  }
}
</style>